const controller = "/chat";
const PATHS = {
  GET_ALL_CHATS: "",
  DOES_CHAT_EXIST: "/participant/:participant_id",
  SEND_FIRST_MESSAGE: "",
  SEND_MESSAGE: "/:chatId/message",
  GET_MESSAGES_IN_CHAT: "/:chatId/messages",
  GET_UNREAD_CHATS: "/unread",
  READ_MESSAGES_IN_CHAT: "/:chatId/read",
  GET_OTHER_PARTICIPANT: "/:chatId/other",
  GET_CHAT_DETAILS: "/:chatId/details",

  EDIT_MESSAGE: "/:chatId/messages/:messageId",
  DELETE_MESSAGE: "/:chatId/messages/:messageId",
};

export const ChatApiRoutes = {
  CONTROLLER: "/chat",
  PATHS,
  GET_ALL_CHATS: `${controller}${PATHS.GET_ALL_CHATS}`,
  SEND_FIRST_MESSAGE: `${controller}${PATHS.SEND_FIRST_MESSAGE}`,
  DOES_CHAT_EXIST: (participant_id: string | undefined) =>
    `${controller}${PATHS.DOES_CHAT_EXIST.replace(
      ":participant_id",
      String(participant_id)
    )}`,
  SEND_MESSAGE: (chatId: string | undefined) =>
    `${controller}${PATHS.SEND_MESSAGE.replace(":chatId", String(chatId))}`,
  GET_MESSAGES_IN_CHAT: (chatId: string | undefined) =>
    `${controller}${PATHS.GET_MESSAGES_IN_CHAT.replace(
      ":chatId",
      String(chatId)
    )}`,
  GET_UNREAD_CHATS: `${controller}${PATHS.GET_UNREAD_CHATS}`,
  READ_MESSAGES_IN_CHAT: (chatId: string | undefined) =>
    `${controller}${PATHS.READ_MESSAGES_IN_CHAT.replace(
      ":chatId",
      String(chatId)
    )}`,
  GET_OTHER_PARTICIPANT: (chatId: string | undefined) =>
    `${controller}${PATHS.GET_OTHER_PARTICIPANT.replace(
      ":chatId",
      String(chatId)
    )}`,
  GET_CHAT_DETAILS: (chatId: string | undefined) =>
    `${controller}${PATHS.GET_CHAT_DETAILS.replace(":chatId", String(chatId))}`,

  EDIT_MESSAGE: (chatId: string | undefined, messageId: string | undefined) =>
    `${controller}${PATHS.EDIT_MESSAGE.replace(
      ":chatId",
      String(chatId)
    ).replace(":messageId", String(messageId))}`,
  DELETE_MESSAGE: (chatId: string | undefined, messageId: string | undefined) =>
    `${controller}${PATHS.DELETE_MESSAGE.replace(
      ":chatId",
      String(chatId)
    ).replace(":messageId", String(messageId))}`,
};
